import { mapDTO } from '@twistezo/ts-dto-mapper'
import { WorkspaceAmazonFragmentForGetFragment } from 'gql/graphql'

import { WorkspaceAmazonSlice } from '../types'

type From = WorkspaceAmazonFragmentForGetFragment
type To = WorkspaceAmazonSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((workspaceAmazonSliceDTO: From): To => {
    const { enabled, id, pubId } = workspaceAmazonSliceDTO

    return {
      enabled,
      id,
      pubId: pubId ?? undefined,
    }
  })
